import BackgroundItem from './item';

export default class Background {

	el = {};
	items = {};

	active = null;
	mode = 'dark';

	constructor({
		scene,
		clock,
		sizes,
		geometry
	}) {

		this.scene = scene;
		this.clock = clock;
		this.sizes = sizes;

		this.active = 'green';

		this.el = {
			buttons: document.querySelectorAll('[data-bg-color-theme]')
		};

		this.background = new BackgroundItem({ sizes: this.sizes, geometry });
	}

	init() {
		this.scene.add(this.background);
		this.addEventListeners();
	}

	resize({ sizes }) {
		this.sizes = sizes;
		this.background.resize({ sizes: this.sizes });
	}

	addEventListeners() {
		for (const button of this.el.buttons) {
			button.addEventListener('click', this.#onButtonClick);
		}
	}

	removeEventListeners() {
		for (const button of this.el.buttons) {
			button.removeEventListener('click', this.#onButtonClick);
		}
	}

	#onButtonClick = (e) => {
		const { currentTarget } = e;
		const { bgColorTheme } = currentTarget.dataset;
		for (const sibling of currentTarget.parentElement.parentElement.children) {
			if (sibling.classList.contains('is-active')) {
				sibling.classList.remove('is-active');
			}
		}
		currentTarget.parentElement.classList.add('is-active');
		this.changeColor(bgColorTheme);
	}

	changeColor(color) {
		const wasActive = this.active ? this.active : 'green';

		if (!this.background.isAnimating) {
			this.active = color;
			if (wasActive === this.active) return;
			this.active === 'green' ? this.theme = 'dark' : this.theme = 'light';
			this.background.change(wasActive, this.active);
			this.setTheme();
		}
	}

	changeCaseStudy() {
		this.background.change('green', 'tan', false);
	}

	setColor(color = false) {
		const wasActive = this.active ? this.active : 'green';

		if (color && !this.background.isAnimating) {
			this.background.set(wasActive, color);
		} else {
			this.background.set(wasActive, this.active);
		}
	}

	setTheme() {
		if (this.theme === 'light') {
			document.documentElement.classList.add('is-light-theme');
		} else {
			document.documentElement.classList.remove('is-light-theme');
		}
	}

	destroy() {
		this.removeEventListeners();
	}

}
